const isIE = () => /Trident\/|MSIE/.test(window.navigator.userAgent);

const showBrowserAlert = function () {
  if (!isIE()) {
    return;
  }
  const banner = document.querySelector<HTMLDivElement>('.unsupported-browser');
  if (banner) {
    const msg = banner.querySelector<HTMLDivElement>('.unsupported-browser__msg');

    if (msg) {
      msg.innerHTML =
        '<b>Unsupported Browser!</b><br>To get the best and most secure experience, we recommend that you upgrade or use a supported browser: Chrome, Firefox, Safari, or Edge.';
      banner.classList.add('unsupported-browser--show');
    }
  }
};

document.addEventListener('DOMContentLoaded', showBrowserAlert);
